import { render, staticRenderFns } from "./program_scheme.vue?vue&type=template&id=8e98b034"
import script from "./program_scheme.vue?vue&type=script&lang=js"
export * from "./program_scheme.vue?vue&type=script&lang=js"
import style0 from "./program_scheme.vue?vue&type=style&index=0&id=8e98b034&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports